function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * vue-load-image v0.1.7
 * (c) 2019 Lee Sangwon <john0152@naver.com>
 * Released under the MIT License.
 */
!function (t, e) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module))) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    var r = e();

    for (var n in r) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : t)[n] = r[n];
    }
  }
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 0);
  }([function (t, e, r) {
    "use strict";

    r.r(e);
    var n = "pending",
        o = "loading",
        s = "loaded",
        i = "failed";

    var a = function (t, e, r, n, o, s, i, a) {
      var u,
          d = "function" == typeof t ? t.options : t;
      if (e && (d.render = e, d.staticRenderFns = r, d._compiled = !0), n && (d.functional = !0), s && (d._scopeId = "data-v-" + s), i ? (u = function u(t) {
        (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(i);
      }, d._ssrRegister = u) : o && (u = a ? function () {
        o.call(this, this.$root.$options.shadowRoot);
      } : o), u) if (d.functional) {
        d._injectStyles = u;
        var l = d.render;

        d.render = function (t, e) {
          return u.call(e), l(t, e);
        };
      } else {
        var c = d.beforeCreate;
        d.beforeCreate = c ? [].concat(c, u) : [u];
      }
      return {
        exports: t,
        options: d
      };
    }({
      data: function data() {
        return {
          status: null,
          img: null,
          src: null
        };
      },
      created: function created() {
        this.src = this.$slots.image[0].data.attrs.src || this.$slots.image[0].data.attrs["data-src"], this.src ? (this.status = o, this.createLoader()) : this.status = n;
      },
      updated: function updated() {
        var t = this.$slots.image[0].data.attrs.src || this.$slots.image[0].data.attrs["data-src"];
        this.status !== o || this.img ? this.src !== t && (this.src = t, this.createLoader()) : this.createLoader();
      },
      watch: {
        src: function src(t) {
          this.status = t ? o : n;
        }
      },
      methods: {
        createLoader: function createLoader() {
          this.destroyLoader(), this.img = new Image(), this.img.onload = this.handleLoad, this.img.onerror = this.handleError, this.img.src = this.src;
        },
        destroyLoader: function destroyLoader() {
          this.img && (this.img.onload = null, this.img.onerror = null, this.img = null);
        },
        handleLoad: function handleLoad() {
          this.destroyLoader(), this.status = s, this.$emit("onLoad");
        },
        handleError: function handleError(t) {
          this.destroyLoader(), this.status = i, this.$emit("onError", t);
        }
      }
    }, function () {
      var t = this.$createElement;
      return (this._self._c || t)("div", {
        staticClass: "vue-load-image"
      }, ["loaded" === this.status ? this._t("image") : "failed" === this.status ? this._t("error") : "loading" === this.status ? this._t("preloader") : this._e()], 2);
    }, [], !1, null, null, null);

    a.options.__file = "VueLoadImage.vue";
    var u = a.exports;
    e.default = u;
  }]);
});